import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        alignment: {
            'top-center': {
                container: {
                    alignItems: {base: 'center', sm: 'center', md: 'center', lg: 'flex-start'},
                    justifyContent: 'center',
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    marginTop: remCalc(40),
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'middle-right': {
                container: {
                    layerStyle: 'page',
                    alignItems: 'center',
                    justifyContent: {base: 'center', sm: 'center', md: 'center', lg: 'flex-end'},
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: remCalc(688),
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'bottom-center': {
                container: {
                    alignItems: {base: 'center', sm: 'center', md: 'center', lg: 'flex-end'},
                    justifyContent: 'center',
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: '100%',
                    marginBottom: remCalc(40),
                    alignItems: 'center',
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'middle-left': {
                container: {
                    layerStyle: 'page',
                    alignItems: 'center',
                    justifyContent: {base: 'center', sm: 'center', md: 'center', lg: 'flex-start'},
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: remCalc(688),
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'middle-center': {
                container: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
        },
    },
}
